// // import { Box, Typography, Divider } from "@mui/material";
// // import React from "react";
// // import attendMeImage from "../assets/home.png";
// // const HeaderBannerPage = () => {
// //   return (
// //     <Box sx={{ margin: 0, padding: 0, width: "90vw", overflow: "hidden" }}>
// //       {/* Banner Section */}
// //       <Box
// //         sx={{
// //           position: "absolute",
// //           top: 0,
// //           left: 0,
// //           right: 0,
// //           width: "100vw",
// //           height: "210px",
// //           overflow: "hidden",
// //         }}
// //       >
// //         <img
// //           src={attendMeImage}
// //           alt="AttendMe Banner"
// //           style={{
// //             width: "100%",
// //             height: "100%",
// //             objectFit: "cover",
// //             display: "block",
// //           }}
// //         />
// //       </Box>
// //       {/* Welcome Section */}
// //       <Typography
// //         variant="h5"
// //         align="center
// //         "
// //         fontWeight="bold"
// //         color="#142c54"
// //         gutterBottom
// //         sx={{ marginTop: "150px" }} // Adjust for the banner height
// //       >
// //         {new Date().getHours() < 12 ? "සූබ උදැසනක්...!" : "සූබ සන්ද්‍යාවක්...!"}
// //       </Typography>
// //       {/* Divider Section */}
// //       <Divider
// //         sx={{
// //           my: 2,
// //           borderBottomWidth: 1,
// //           borderColor: "#142c54",
// //           width: "90%",
// //           margin: "16px auto",
// //         }}
// //       />
// //     </Box>
// //   );
// // };
// // export default HeaderBannerPage;



// import { Box, Typography, Divider, useMediaQuery, useTheme } from "@mui/material";
// import React, { useState, useEffect } from "react";
// import attendMeMobileImage from "../assets/home.png";
// import attendMeDesktopImage from "../assets/Sri-Dalada-Maligawa_1920x700-1.png"; // You'll need to add this image

// const HeaderBannerPage = () => {
//   const [greeting, setGreeting] = useState("");
//   const [useFirstWord, setUseFirstWord] = useState(true);
//   const [isMorning, setIsMorning] = useState(true);
  
//   // Use MUI theme to detect screen size
  
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md')); // or 'sm' depending on your needs

//   useEffect(() => {
//     // Check if it's morning or evening based on current time
//     const currentIsMorning = new Date().getHours() < 12;
//     setIsMorning(currentIsMorning);
    
//     // Set initial word based on time of day
//     if (currentIsMorning) {
//       // Morning greetings: alternate between two words
//       setGreeting(useFirstWord ? "සූබ උදැසනක්...!" : "සූබ උදැසනක්...!");
//     } else {
//       // Evening greetings: alternate between two words  
//       setGreeting(useFirstWord ? "සූබ සන්ද්‍යාවක්...!" : "සූබ සන්ද්‍යාවක් ...!");
//     }

//     // Set up interval to toggle between the two words every 5 seconds
//     const interval = setInterval(() => {
//       setUseFirstWord(prev => {
//         const newUseFirstWord = !prev;
        
//         // Update greeting based on current time of day
//         if (currentIsMorning) {
//           setGreeting(newUseFirstWord ? "සූබ උදැසනක්...!" : "Good Morning...!");
//         } else {
//           setGreeting(newUseFirstWord ? "සූබ සන්ද්‍යාවක්...!" : "Good Evening...!");
//         }
        
//         return newUseFirstWord;
//       });
//     }, 5000);

//     // Cleanup interval on component unmount
//     return () => clearInterval(interval);
//   }, []);

//   // Choose image based on screen size
//   const bannerImage = isMobile ? attendMeMobileImage : attendMeDesktopImage;

//   return (
//     <Box sx={{ margin: 0, padding: 0, width: "90vw", overflow: "hidden" }}>
//       {/* Banner Section */}
//       <Box
//         sx={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           right: 0,
//           width: "100vw",
//           height: { xs: "210px", md: "250px" }, // Different heights for mobile/desktop
//           overflow: "hidden",
//         }}
//       >
//         <img
//           src={bannerImage}
//           alt="AttendMe Banner"
//           style={{
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             display: "block",
//           }}
//         />
//       </Box>

//       {/* Welcome Section */}
//       <Typography
//         variant="body1"
//         align="center"
//         fontWeight="bold"
//         color="#142c54"
//         gutterBottom
//         sx={{ 
//           marginTop: { xs: "130px", md: "200px" }, // Adjust margin based on screen size
//         }}
//       >
//         {greeting}
//       </Typography>

//       {/* Divider Section */}
//       <Divider
//         sx={{
//           my: 2,
//           borderBottomWidth: 1,
//           borderColor: "#142c54",
//           width: "90%",
//           margin: "20px auto",
//         }}
//       />
//     </Box>
//   );
// };

// export default HeaderBannerPage;

// components/HeaderBannerPage.js
import { Box, Typography, Divider, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { apiUrl } from "../service/apiUrl";

const HeaderBannerPage = () => {
  const [greeting, setGreeting] = useState("");
  const [useFirstWord, setUseFirstWord] = useState(true);
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  // Direct API URL - no need for blob or base64 conversion
  const positionID = isMobile ? 'mob1' : 'desk1';
  const bannerUrl = apiUrl(`Configuration/GetInterfaceImg?positionID=${positionID}`);

  useEffect(() => {
    const currentIsMorning = new Date().getHours() < 12;
    
    if (currentIsMorning) {
      setGreeting(useFirstWord ? "සූබ උදැසනක්...!" : "සූබ උදැසනක්...!");
    } else {
      setGreeting(useFirstWord ? "සූබ සන්ද්‍යාවක්...!" : "සූබ සන්ද්‍යාවක් ...!");
    }

    const interval = setInterval(() => {
      setUseFirstWord(prev => {
        const newUseFirstWord = !prev;
        const isMorning = new Date().getHours() < 12;
        
        if (isMorning) {
          setGreeting(newUseFirstWord ? "සූබ උදැසනක්...!" : "Good Morning...!");
        } else {
          setGreeting(newUseFirstWord ? "සූබ සන්ද්‍යාවක්...!" : "Good Evening...!");
        }
        
        return newUseFirstWord;
      });
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ margin: 0, padding: 0, width: "90vw", overflow: "hidden" }}>
      {/* Banner Section */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          width: "100vw",
          height: { xs: "210px", md: "250px" },
          overflow: "hidden",
        }}
      >
        <img
          src={bannerUrl}
          alt="Banner"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
          // Add error handling in case the API fails
          onError={(e) => {
            console.error('Failed to load banner:', e);
            // Optionally set a fallback color background
            e.target.style.backgroundColor = '#f0f0f0';
          }}
        />
      </Box>

      {/* Welcome Section */}
      <Typography
        variant="body1"
        align="center"
        fontWeight="bold"
        color="#142c54"
        gutterBottom
        sx={{ 
          marginTop: { xs: "130px", md: "200px" },
        }}
      >
        {greeting}
      </Typography>

      {/* Divider Section */}
      <Divider
        sx={{
          my: 2,
          borderBottomWidth: 1,
          borderColor: "#142c54",
          width: "90%",
          margin: "20px auto",
        }}
      />
    </Box>
  );
};

export default HeaderBannerPage;